import React from 'react';
import { FileTextIcon, ZapIcon, ShieldCheckIcon, StarIcon } from 'lucide-react';
import { CtaButton } from './CtaButton';
import { PACKSHOT_URL, testimoniosCortos } from '../data/content';
const badges = [{
  icon: FileTextIcon,
  label: '100% PDF'
}, {
  icon: ZapIcon,
  label: 'Acceso en 5 min'
}, {
  icon: ShieldCheckIcon,
  label: 'Garantía 7 días'
}];
const stats = [{
  value: '+1.200',
  label: 'personas'
}, {
  value: '6',
  label: 'tomos'
}, {
  value: '6',
  label: 'bonos'
}, {
  value: '4.9/5',
  label: 'valoración'
}];
export function Hero() {
  return <header className="relative w-full overflow-hidden bg-ink" data-id="element-88" data-mp="sbb1bcug66bq">
      <div className="pointer-events-none absolute inset-x-0 top-0 h-px bg-leaf/40" aria-hidden="true" data-id="element-89" data-mp="s9gh60r02i8p" />
      <div className="mx-auto grid max-w-6xl items-center gap-12 px-5 pb-16 pt-10 sm:px-8 lg:grid-cols-[1.05fr_0.95fr] lg:gap-10 lg:pb-24 lg:pt-16" data-id="element-90" data-mp="3d1ikzavvpeny">
        <div data-id="element-91" data-mp="381nv9anuav4h">
          <p className="font-display text-sm font-bold uppercase tracking-[0.3em] text-leaf" data-id="element-92" data-mp="380w0u35zb3fs">
            🧠 AtajoDigital™
          </p>
          <h1 className="mt-5 font-display text-4xl font-extrabold leading-[0.98] text-cream sm:text-5xl lg:text-6xl" data-id="element-93" data-mp="3o7lq5lizewmb">
            Todo tu Reset.
            <br data-id="element-94" data-mp="399jojgvigl7p" />
            Listo. <span className="text-leaf" data-id="element-95" data-mp="39cflb1vmh3uk">Desde hoy.</span>
          </h1>
          <p className="mt-6 font-display text-xl font-bold text-cream sm:text-2xl" data-id="element-96" data-mp="3e84nlcz10yuk">
            Reset Integral — Combo Completo
          </p>
          <p className="mt-3 max-w-xl text-base leading-relaxed text-cream/70" data-id="element-97" data-mp="30g6l3kztm17d">
            El sistema N°1 de reconfiguración personal para adultos en
            Argentina.
          </p>
          <p className="mt-4 flex flex-wrap gap-x-3 gap-y-1 text-sm font-semibold uppercase tracking-wide text-cream/55" data-id="element-98" data-mp="2qhqvjmgfyzzz">
            {['Mente', 'Sueño', 'Hábitos', 'Energía', 'Organización', 'Propósito'].map((pilar, i) => <span key={pilar} className="flex items-center gap-3" data-id="element-99" data-mp="s1rr4kwyw0sp" data-mpi={i}>
                {i > 0 && <span className="text-leaf/60" data-id="element-100" data-mp="s3urnyvqxcbo">·</span>}
                {pilar}
              </span>)}
          </p>

          <ul className="mt-8 grid max-w-xl grid-cols-1 gap-2.5 sm:grid-cols-3" data-id="element-101" data-mp="iboyiltrcouw">
            {badges.map(badge => <li key={badge.label} className="flex items-center justify-center gap-2 rounded-full border border-ink-600 bg-ink-800 px-3 py-2 text-center text-[13px] font-medium text-cream/80" data-id="element-102" data-mp="de6munocvvj7">
                <badge.icon className="h-4 w-4 shrink-0 text-leaf" aria-hidden="true" data-id="element-103" data-mp="15zq5vrf79z8q" />
                <span className="whitespace-nowrap" data-id="element-104" data-mp="x1ny8t0yo8ch">{badge.label}</span>
              </li>)}
          </ul>

          <div className="mt-9 max-w-md" data-id="element-105" data-mp="3lu07neppzt62">
            <CtaButton data-id="element-106" data-mp="3lqm2jypo95ux">Quiero mi Reset Integral ahora</CtaButton>
            <p className="mt-3 text-center text-[13px] text-cream/50" data-id="element-107" data-mp="3hqk6q66mb6nk">
              💳 Mercado Pago · Tarjeta · Transferencia
            </p>
          </div>
        </div>

        <div className="relative" data-id="element-108" data-mp="21a4sds29ic4e">
          <img src={PACKSHOT_URL} alt="Caja del sistema Reset Integral con los seis tomos: Mente Consciente, Arquitectura del Sueño, Hábitos de Hierro, Energía y Nutrición, Gestión del Estrés y Vida con Propósito" className="mx-auto w-full max-w-[560px]" width={1240} height={1240} data-id="element-109" data-mp="21bfxpwbcvrxm" />
        </div>
      </div>

      <div className="border-y border-ink-600 bg-ink-800" data-id="element-110" data-mp="2kxu8h20u6nxs">
        <div className="mx-auto flex max-w-6xl flex-wrap items-center justify-center gap-x-10 gap-y-4 px-5 py-5 sm:px-8" data-id="element-111" data-mp="2p0qnkir641wz">
          {stats.map(stat => <p key={stat.label} className="flex items-baseline gap-2" data-id="element-112" data-mp="2tz20518ukqiw">
              <span className="font-display text-xl font-extrabold text-cream" data-id="element-113" data-mp="unj1bfh9cymy">
                {stat.value}
              </span>
              <span className="text-sm uppercase tracking-wide text-cream/50" data-id="element-114" data-mp="zlsxntepy5a5">
                {stat.label}
              </span>
            </p>)}
        </div>
      </div>

      <div className="mx-auto grid max-w-6xl gap-4 px-5 py-10 sm:px-8 md:grid-cols-3" data-id="element-115" data-mp="3vgvven7a573m">
        {testimoniosCortos.map(t => <figure key={t.author} className="flex h-full flex-col rounded-2xl border border-ink-600 bg-ink-800 p-5" data-id="element-116" data-mp="e7h8pdeunmor">
            <div className="flex gap-0.5" aria-label="5 de 5 estrellas" data-id="element-117" data-mp="3hph8446cajqr">
              {Array.from({
            length: 5
          }).map((_, i) => <StarIcon key={i} className="h-4 w-4 fill-gold text-gold" aria-hidden="true" data-id="element-118" data-mp="3ct0nvl29gpiy" data-mpi={i} />)}
            </div>
            <blockquote className="mt-3 text-[15px] leading-relaxed text-cream/85" data-id="element-119" data-mp="3mo2bgcgw1jjf">
              “{t.quote}”
            </blockquote>
            <figcaption className="mt-auto pt-4 text-[13px] font-semibold text-cream/55" data-id="element-120" data-mp="2u0ps0b60xruc">
              {t.author} — {t.city}
            </figcaption>
          </figure>)}
      </div>
    </header>;
}